// Accounting period (período contable) — mirrors Finance.API AccountingPeriodDto.
// Journal entries may only post to an Open period; ClosingOnly accepts period-end / adjustment
// (closing) postings only; Closed accepts none (#4711).

export enum AccountingPeriodStatus {
  Open = 1,
  Closed = 2,
  ClosingOnly = 3,
}

export interface AccountingPeriod {
  id?: string;
  fiscalYear: number;
  period: number; // 1–12
  periodName: string;
  startDate: string; // ISO date
  endDate: string; // ISO date
  financialCompanyReference: string;
  status: AccountingPeriodStatus;
  createdBy?: string | null;
  createdDate?: string | null;
  modifiedBy?: string | null;
  modifiedDate?: string | null;
}

// Body for POST /api/v1/accounting-periods/generate.
export interface GenerateAccountingPeriodsRequest {
  financialCompanyReference: string;
  fiscalYear: number;
}

// Result of GET /api/v1/accounting-periods/posting-date-deviation (#4714) — non-blocking advisory.
export interface PostingDateDeviation {
  postingDate: string;
  systemDate: string;
  deviationDays: number;
  thresholdDays: number;
  exceedsThreshold: boolean;
  message?: string | null;
}
